
import { Link } from "react-router-dom";
const Footer = ()=>{
    return <footer className="flex flex-col text-headline dark:text-headline-dark font-heading py-4 bg-secondary dark:bg-background-dark shadow-upper">
        <span className="flex md:flex-row flex-col md:justify-evenly items-center ">
            <Link className="md:text-md text-sm lg:text-lg" to={"/Privacy"}>Privacy Policy</Link>
            <Link className="md:text-lg lg:text-xl text-md tracking-wider" to={"/"}>{'<UNIQUE/>'}</Link>
            <button className="md:text-md text-sm lg:text-lg ">Contact Me</button>

        </span>
        <h3 className="md:text-md text-sm font-heading text-center mt-2">Copyright &#169; {new Date().getFullYear()} Cliff Likovo</h3>
    </footer>
}

export default Footer;